import styled from "styled-components";

interface OperacaoTagProps {
  value: any[];
}

function OperacaoTag({ value }: OperacaoTagProps) {
  return (
    <Container>
      {value.map(v => (
        <Tag>{v.operacao}</Tag>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px
`;

const Tag = styled.p`
  background-color: #e3f2fd;
  color: #1976d2;
  font-size: 12px;
  border-radius: 5px;
  padding: 4px;
`;

export default OperacaoTag;
